/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { EnvironmentService } from '../service/service.module';
import { LocalstorageService } from '../config/localstorage.service'
@Injectable({ providedIn: 'root' })
export class ReplenishmentService {
  public environment = EnvironmentService.environment;
  constructor(private http: HttpClient, public storage: LocalstorageService) {
  }
  // Replenishment User Profile
  CreateReplUserProfile(Profile: any): Observable<any> {
    return this.http.post(`${this.environment.DataPERM}/CreateReplUserProfile`, Profile);
  }
  UpdateReplUserProfile(Profile: any): Observable<any> {
    return this.http.post(`${this.environment.DataPERM}/UpdateReplUserProfile`, Profile);
  }
  UpdateProfileCombos(Profile: any): Observable<any> {
    return this.http.post(`${this.environment.DataPERM}/UpdateProfileCombos`, Profile);
  }
  GetProfileItemAccountCombosById(params: any): Observable<any> {
    return this.http.get<any>(`${this.environment.DataPERM}/GetProfileItemAccountCombosByProfileId`, { params });
  }
  GetReplUserProfileById(params: any): Observable<any> {
    return this.http.get<any>(`${this.environment.DataPERM}/GetReplUserProfileById`, { params });
  }
  GetAllReplUserProfiles(params: any): Observable<any> {
    return this.http.get<any>(`${this.environment.DataPERM}/GetAllReplUserProfiles`, { params });
  }
  DeleteProfileComboById(Profile: any): Observable<any> {
    return this.http.delete(`${this.environment.DataPERM}/DeleteProfileComboById/${Profile.comboId}`);
  }
  DeleteProfile(Profile: any): Observable<any> {
    return this.http.delete(`${this.environment.DataPERM}/DeleteProfile`, { body: Profile });
  }
  ReplUserProfileCombosBulkDelete(params: any): Observable<any> {
    return this.http.delete<any>(`${this.environment.DataPERM}/BulkDelete`, { body: params });
  }
  // Replenishment User Profile

  // Replenishment Exception Management
  CreateException(Exception: any): Observable<any> {
    return this.http.post(`${this.environment.AppException}/Create`, Exception);
  }
  UpdateException(Exception: any): Observable<any> {
    return this.http.post(`${this.environment.AppException}/Update`, Exception);
  }
  DeleteException(Exception: any): Observable<any> {
    return this.http.delete<any>(`${this.environment.AppException}/Delete`, { body: Exception });
  }
  DeleteConfig(Exception: any): Observable<any> {
    return this.http.delete(`${this.environment.AppException}/DeleteConfig`, { body: Exception });
  }
  GetExceptionById(params: any): Observable<any> {
    return this.http.get<any>(`${this.environment.AppException}/Get`, { params });
  }
  GetExcConfigById(params: any): Observable<any> {
    return this.http.get<any>(`${this.environment.AppException}/GetExcConfigById`, { params });
  }
  GetExceptionList(params: any): Observable<any> {
    return this.http.get<any>(`${this.environment.AppException}/GetAll`, params);
  }
  ReplExceptionProfileCombosBulkDelete(params: any): Observable<any> {
    return this.http.delete<any>(`${this.environment.AppException}/BulkDelete`, { body: params });
  }
 GetExceptionHierarchy(params:any): Observable<any> {
    return this.http.get<any>(`${this.environment.AppException}/GetExceptionHierarchy`,{params});
  }
  AddException(params: any): Observable<any> {
    return this.http.post(`${this.environment.AppException}/AddExceptionCriteria`, params );
  }
  // Replenishment Exception Management
  ImportPOG(model: any) {
    var formData = new FormData();
    formData.append('file', model.file);
    formData.append('RangeUploadType', model.RangeUploadType);
    formData.append('tablename', model.tableName);
    formData.append('currentUserId', model.userId);
    return this.http.post<Array<any>>(`${this.environment.ReplenishmentPOG}/ImportPOG`, formData);
  }
  AddReplenishmentConfig(model: any) {
    return this.http.post<Array<any>>(`${this.environment.ReplenishmentConfig}/Add`, model);
  }
  GetAllPOGList(params: any): Observable<any> {
    return this.http.post<any>(`${this.environment.ReplenishmentPOG}/GetAll`, params);
  }

  GetAllRangeConfigById(params: any): Observable<any> {
    return this.http.get<any>(`${this.environment.ReplenishmentPOG}/GetAllRangeConfigById`, {params});
  }
  
  GetRangeType(params: any): Observable<any> {
    return this.http.post<any>(`${this.environment.ReplenishmentPOG}/GetAllRangeType`, params);
  }

  GetReplenishmentConfig(): Observable<any> {
    return this.http.get<any>(`${this.environment.ReplenishmentConfig}/Get`);
  }
  UpdateReplenishmentConfig(model: any) {
    return this.http.put<Array<any>>(`${this.environment.ReplenishmentConfig}/Update`,model);
  }
  UploadStorePriority(model: any)
  {
    var formData = new FormData();
    formData.append('file', model.file);
    formData.append('tablename', model.tableName);
    return this.http.post<Array<any>>(`${this.environment.ReplenishmentConfig}/UploadStorePriorityCSV`, formData);
  }
  // Replenishment Review
  RunReplReview(model: any): Observable<any> {
    return this.http.post(`${this.environment.ReplenishmentReview}/RunReplenishment`, model);
  }
  GetReplReviewById(params: any): Observable<any> {
    return this.http.get<any>(`${this.environment.ReplenishmentReview}/GetbyId`, { params });
  }
  GetAllReviewData(params: any): Observable<any> {
    return this.http.get<any>(`${this.environment.ReplenishmentReview}/GetAllReviewData?${params}`);
  }
  GetExcpReviewData(params: any): Observable<any> {
    return this.http.get<any>(`${this.environment.ReplenishmentReview}/GetExceptionData?${params}`);
  }
  GetDropDownList(params: any): Observable<any> {
    return this.http.get<any>(`${this.environment.ReplenishmentReview}/GetAllReviewIds`, { params });
  }
  UpdateReplReview(model: any): Observable<any> {
    return this.http.put(`${this.environment.ReplenishmentReview}/Update`, model);
  }
  CreateReplJob(model: any): Observable<any> {
    return this.http.post(`${this.environment.ReplenishmentReview}/CreateReplJob`, model);
  }
  GetReplJobsByUserId(params: any): Observable<any> {
    return this.http.get(`${this.environment.ReplenishmentReview}/GetReplJobsByUserId?userId=${params}`);
  }
  UpdateExceptionStatus(model: any): Observable<any> {
    return this.http.post(`${this.environment.ReplenishmentReview}/UpdateExceptionStatus`, model);
  }
  AddReplenishmentSummary(model: any): Observable<any> {
    return this.http.post(`${this.environment.ReplenishmentReview}/AddReplenishmentSummary`, model);
  }
  GetReplenishmentSummary(params: any): Observable<any> {
    return this.http.get<any>(`${this.environment.ReplenishmentReview}/GetReplenishmentSummary?replSummaryId=${params}`);
  }
  ExportExceptionData(params: any): Observable<any> {
    return this.http.post(`${this.environment.ReplenishmentReview}/ExportExceptionData?replReviewId=${params}`,{}, {
      observe: 'response',
      responseType: 'blob',
    });
  }
  GetRejectedExceptions(params: any): Observable<any> {
    return this.http.get<any>(`${this.environment.ReplenishmentReview}/GetRejectedExceptions?${params}`);
  }

  CreateProfileCombos(Profile: any): Observable<any> {
    return this.http.post(`${this.environment.DataPERM}/Add`, Profile);
  }
  GetAllAssignedReplUserProfiles(params: any): Observable<any> {
    return this.http.get(`${this.environment.DataPERM}/GetAllAssignedReplUserProfiles?UserId=${params}`);
  }

  // Order Managment
  AddOrderList(model: any) {
    return this.http.post(`${this.environment.OrderManagement}/AddList`,model);
  }
  GetReplOrderList(params:any){
    return this.http.post( `${this.environment.OrderManagement}/GetAll`,params);
  }
  GenerateOrder(params:any){
    return this.http.post( `${this.environment.OrderManagement}/Order`,params);
  }
  AllReplOrder(params:any){
    return this.http.post( `${this.environment.OrderManagement}/GetAllOrders`,params);
  }
  ReplOrderXml(params:any){
    return this.http.post( `${this.environment.OrderManagement}/GenerateOrderXML`,params);
  }
  GetAllOrderList(params:any){
    return this.http.post( `${this.environment.OrderManagement}/GetAllPaginatedOrders`,params);
  }
   DeleteGroupOrders = (params: any) => {
    return this.http.post<any>(
      `${this.environment.OrderManagement}/DeleteReplOrderGroup`, params
    );
  };
    GetOrderFilters(): Observable<any> {
    return this.http.get<any>(`${this.environment.OrderManagement}/GetOrderFilters`, {});
  }
      ValidateAndGenerateXML
  = (params: any) => {
    return this.http.post<any>(`${this.environment.OrderManagement}/ValidateAndGenerateXML`, params);
  }
  
   UpdateOrderById = (data: any) => {
    return this.http.post(`${this.environment.OrderManagement}/UpdateOrderById`, data);
  };

  // Ranging Family
  GetAllFamilyGrade = (query: any) => {
    return this.http.post<any>(
      `${this.environment.ReplenishmentPOG}/GetAllFamilyGrade`, query
    );
  };
  ImportFamilyGrade(params: any): Observable<any> {
    var formData = new FormData();
    formData.append('file', params.file);
    formData.append('userId', params.userId);
    return this.http.post<Array<any>>(
      `${this.environment.ReplenishmentPOG}/ImportFamilyGrade`,
      formData
    );
  }
  GetFamilyGradeById(params: any): Observable<any> {
    return this.http.post<any>(`${this.environment.ReplenishmentPOG}/GetFamilyGradeById`, params);
  }
  GetRangeConfigById(params: any): Observable<any> {
    return this.http.post<any>(`${this.environment.ReplenishmentPOG}/GetRangeConfigById`, params);
  }
  UpdateFamilyGradeById = (data: any) => {
    return this.http.put(`${this.environment.ReplenishmentPOG}/UpdateFamilyGradeById`, data);
  };
  BulkUpdate = (data: any) => {
    return this.http.post(`${this.environment.ReplenishmentPOG}/BulkUpdate`, data);
  };
  UpdateRangeConfigById = (data: any) => {
    return this.http.put(`${this.environment.ReplenishmentPOG}/UpdateRangeConfigById`, data);
  };

  GetAllFamilyGradeById(params: any): Observable<any> {
    return this.http.get<any>(`${this.environment.ReplenishmentPOG}/GetAllFamilyGradeById`, {params});
  }

    GetAllStoreTransfer = (query: any) => {
    return this.http.post<any>(
      `${this.environment.StoreTransfer}/GetAll`, query
    );
  };
    GetStoreTransfer = (params: any) => {
    return this.http.get<any>(
      `${this.environment.StoreTransfer}/Get`, {params}
    );
  };
    GetStoreTransferSummary = (params: any) => {
    return this.http.post<any>(
      `${this.environment.StoreTransfer}/GetStoreTransferSummary`, params
    );
  };
  AddStoreTransfer = (data: any) => {
    return this.http.post<any>(`${this.environment.StoreTransfer}/Add`, data);
  };
  UpdateStoreTransfer = (data: any) => {
    return this.http.post(`${this.environment.StoreTransfer}/Update`, data);
  };

  ExportFamilyGrade(params: any): Observable<any> {
    return this.http.post(`${this.environment.ReplenishmentPOG}/ExportFamilyGrade`, params, {
      observe: 'response',
      responseType: 'blob',
    });
  }
    ExportStoreTransferSummary(params: any): Observable<any> {
    return this.http.post(`${this.environment.StoreTransfer}/ExportJob`,params, {
      observe: 'response',
      responseType: 'blob',
    });
  }

  GetPredictionByID = (params: any) => {
    return this.http.get<any>(
      `${this.environment.ClassPrediction}/Get`, { params }
    );
  };
  GetAllPredicitons = (params: any) => {
    return this.http.post<any>(
      `${this.environment.ClassPrediction}/GetAll`, params
    );
  };
  AddPrediction = (data: any) => {
    return this.http.post<any>(`${this.environment.ClassPrediction}/Add`, data);
  };
  UpdatePrediction = (data: any) => {
    return this.http.post(`${this.environment.ClassPrediction}/Update`, data);
  };

  ExportPOG(params: any): Observable<any> {
    return this.http.post(`${this.environment.ReplenishmentPOG}/ExportStoreItemGroupingPaged`, params, {
      observe: 'response',
      responseType: 'blob',
    });
  }
  GetStoreGroupIds = (params: any) => {
    return this.http.get<any>(
      `${this.environment.ReplenishmentPOG}/GetStoreGroupIds`, {params}
    );
  };
  GetRangeIds = (params: any) => {
    return this.http.get<any>(
      `${this.environment.ReplenishmentPOG}/GetRangeIds`, { params }
    );
  };

  GetPredictionSummary = (params: any) => {
    return this.http.post<any>(
      `${this.environment.ClassPrediction}/GetClassPredictionSummary`, params
    );
  };
    ExportPredictionSummary(params: any): Observable<any> {
    return this.http.post(`${this.environment.ClassPrediction}/ExportClassPredictionSummary`, params, {
      observe: 'response',
      responseType: 'blob',
    });
  }

  GetItemIdsBySku = (data: any) => {
    return this.http.post(`${this.environment.StoreTransfer}/GetItemIdsBySku`, data);
  };

   GetAccountIdsBySalesForceIds = (data: any) => {
    return this.http.post(`${this.environment.StoreTransfer}/GetAccountIdsBySalesForceIds`, data);
  };

  DeleteStoreTranferJob = (params: any) => {
    return this.http.post<any>(
      `${this.environment.StoreTransfer}/Delete`, params
    );
  };
  DeleteClassPredictionJob = (params: any) => {
    return this.http.post<any>(
      `${this.environment.ClassPrediction}/Delete`,  params
    );
  };

  GetSeasonCodes(): Observable<string[]> {
    return this.http.get<string[]>(`${this.environment.StoreTransfer}/GetSeasonCodes`);
  }
  GetStoreGroups(): Observable<string[]> {
    return this.http.get<any>(`${this.environment.StoreTransfer}/GetStoreGroups`);
  }
  GetProductGroups(): Observable<any> {
    return this.http.get<any>(`${this.environment.StoreTransfer}/GetProductGroups`);
  }

  GetStoreTransferJobExport(params: any) {
    return this.http.get<any>(`${this.environment.StoreTransfer}/GetStoreTransferJobExport?${params}`);
  }
  ExportReportStoreTransfer(params: any): Observable<any> {
    return this.http.post(`${this.environment.StoreTransfer}/JobExport`,params);
  }
  GetJobExportType(): Observable<any> {
    return this.http.get(`${this.environment.StoreTransfer}/GetJobExportType`);
  }
  
  GetPushOrderByID = (params: any) => {
    return this.http.get<any>(
      `${this.environment.PushOrder}/Get`, { params }
    );
  };
  GetAllPushOrder = (params: any) => {
    return this.http.post<any>(
      `${this.environment.PushOrder}/GetAll`, params
    );
  };
  AddPushOrder = (data: any) => {
    return this.http.post<any>(`${this.environment.PushOrder}/Add`, data);
  };
  UpdatePushOrder = (data: any) => {
    return this.http.post(`${this.environment.PushOrder}/Update`, data);
  };
  GetReplCalcJobIds = (params: any) => {
    return this.http.post<any>(
      `${this.environment.PushOrder}/GetJobDataByReplTypeId`,  params 
    );
  };
  DeletePushOrderJob = (params: any) => {
    return this.http.post<any>(`${this.environment.PushOrder}/Delete`, params);
  }
  GetPushOrderSummary = (params: any) => {
    return this.http.post<any>(
      `${this.environment.PushOrder}/GetPushOrderSummary`, params
    );
  };

  GetAllPlannerDetails(params: any): Observable<any> {
    return this.http.post<any>(`${this.environment.ReplenishmentPOG}/GetAllPlannerDetails`, params);
  }
  ExportPushOrderSummary(params: any): Observable<any> {
    return this.http.post(`${this.environment.PushOrder}/Export`, params, {
      observe: 'response',
      responseType: 'blob',
    });
  }

  GetRangeRankType(params: any): Observable<any> {
    return this.http.get<any>(`${this.environment.ReplenishmentPOG}/GetRangeRankType`, params);
  }
  
  AddRangeType = (data: any) => {
    return this.http.post<any>(`${this.environment.ReplenishmentPOG}/AddRangeType`, data);
  };

  UpdateRangeType = (data: any) => {
    return this.http.post(`${this.environment.ReplenishmentPOG}/UpdateRangeType`, data);
  };

  GetRangeRankTypeAuditTrail(params: any): Observable<any> {
    return this.http.get<any>(`${this.environment.ReplenishmentPOG}/GetRangeRankTypeAuditTrail`, { params });
  }
}
